module.exports = __webpack_public_path__ + "static/img/16.07a66f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/16.png
// module id = g5NW
// module chunks = 0